export const products = [
  {
    id: "hr-assist",
    name: "Hr-Assist",
    url: "https://hr-assist.in",
    description:
      "AI-powered HRMS + ATS + CRM + Staffing platform for recruitment, payroll, employee lifecycle, and workforce automation.",
    longDescription:
      "Hr-Assist unifies recruitment, payroll, employee lifecycle, CRM, and staffing into one AI-powered cloud platform. Built for agencies, HR teams, and growing businesses, it automates candidate matching, streamlines hiring pipelines, and scales workforce operations with intelligent analytics.",
    features: [
      "AI Recruitment",
      "Candidate Matching",
      "Payroll",
      "Employee Lifecycle",
      "CRM",
      "Staffing",
    ],
    status: "live",
    icon: "Groups",
  },
  {
    id: "qshikshak",
    name: "Qshikshak",
    url: "https://qshikshak.com/",
    description:
      "AI-enabled School ERP for admissions, fees, academics, communication, and administration.",
    longDescription:
      "Qshikshak is an AI-enabled School ERP that digitizes admissions, fee management, academics, parent communication, and day-to-day administration. Schools get a single platform to manage students, staff, and operations with smart insights that improve decision-making.",
    features: [
      "Admissions CRM",
      "Student Management",
      "Fees",
      "Communication",
      "AI Insights",
    ],
    status: "live",
    icon: "School",
  },
  {
    id: "leadgen-ai",
    name: "LeadGen AI",
    url: null,
    description:
      "AI-powered lead generation and enrichment platform for modern sales teams.",
    longDescription:
      "LeadGen AI helps sales teams discover, enrich, and prioritize high-intent leads using machine learning. From automated prospecting to CRM-ready data and pipeline scoring, it reduces manual research and accelerates revenue growth.",
    features: ["Lead Enrichment", "AI Scoring", "CRM Sync", "Pipeline Automation"],
    status: "coming-soon",
    icon: "TrendingUp",
  },
  {
    id: "land-intelligence",
    name: "Land Intelligence",
    url: null,
    description:
      "Satellite-powered land intelligence platform for agriculture, land analysis, and risk detection.",
    longDescription:
      "Land Intelligence combines satellite imagery, geospatial analytics, and AI to deliver actionable insights for agriculture, property analysis, and environmental risk detection. Ideal for agri-business, real estate, and land management teams.",
    features: ["Satellite Analysis", "Risk Detection", "Land Mapping", "Agri Insights"],
    status: "coming-soon",
    icon: "SatelliteAlt",
  },
];

export const techStack = {
  intro:
    "Quinterra builds cloud-native AI systems using scalable microservices, secure infrastructure, and machine learning services to deliver enterprise-grade reliability.",
  categories: [
    {
      title: "Frontend",
      items: ["React", "Next.js", "React Native", "Expo"],
    },
    {
      title: "Backend",
      items: ["Node.js", "Express", "Python"],
    },
    {
      title: "Database",
      items: ["MongoDB", "Vector Search"],
    },
    {
      title: "Cloud Infrastructure",
      items: ["AWS EC2", "AWS S3", "AWS CloudFront", "AWS Lambda", "AWS SES"],
    },
    {
      title: "AI Stack",
      items: ["LLMs", "RAG", "Vector Search", "AI Agents", "ML Scoring"],
    },
  ],
};

export const industries = [
  {
    name: "HRTech",
    description: "AI-driven HRMS, ATS, and workforce automation for modern teams.",
    icon: "Badge",
  },
  {
    name: "EdTech",
    description: "Smart school ERP platforms for admissions, academics, and operations.",
    icon: "MenuBook",
  },
  {
    name: "Real Estate Intelligence",
    description: "Satellite and data intelligence for land and property analysis.",
    icon: "Apartment",
  },
  {
    name: "Enterprise SaaS",
    description: "Scalable cloud products for business-critical workflows.",
    icon: "Cloud",
  },
  {
    name: "Operations & Automation",
    description: "Process automation that reduces manual effort at scale.",
    icon: "SettingsSuggest",
  },
  {
    name: "CRM / Sales Tech",
    description: "Lead generation, enrichment, and sales pipeline intelligence.",
    icon: "Handshake",
  },
];

export const whyQuinterra = [
  {
    title: "AI First",
    description: "We embed AI into every product.",
    icon: "Psychology",
  },
  {
    title: "Cloud Native",
    description: "Built for scale and reliability.",
    icon: "CloudQueue",
  },
  {
    title: "Product Thinking",
    description: "We solve business problems, not just engineering tasks.",
    icon: "Lightbulb",
  },
  {
    title: "Enterprise Ready",
    description: "Security, scalability, compliance.",
    icon: "VerifiedUser",
  },
];

export const leadership = [
  {
    name: "Prudhvi Bangaru",
    role: "Founder & CEO",
    bio: "Product leader with 7+ years in product design, frontend engineering, mobile apps, AI integration, and go-to-market execution.",
    linkedin: "https://www.linkedin.com/in/prudhvi-bangaru-7613a3151/",
    initials: "PB",
  },
  {
    name: "Vamshi Krishna",
    role: "CTO",
    bio: "Technology leader specializing in scalable architectures, backend systems, and AI-powered platforms.",
    // linkedin: "https://www.linkedin.com/in/vamshi-krishna/",
    initials: "VK",
  },
];

export const tractionMetrics = [
  { label: "Multiple SaaS Products", value: 4, suffix: "+" },
  { label: "Growing Customer Base", value: 10, suffix: "+" },
  { label: "AI-Powered Automation", value: 100, suffix: "%" },
  { label: "Serving HRTech & EdTech", value: 2, suffix: "" },
];

export const companyInfo = {
  legalName: "Quinterra Software Solutions Pvt. Ltd.",
  founded: "2021",
  headquarters: "Hyderabad, Telangana, India",
  businessModel: "SaaS Subscription + Enterprise Licensing",
  stage: "Bootstrapped / Pre-seed",
  cin: "CIN: U72200TG2021PTC157035",
  // gstin: "GSTIN: [To be updated]",
  email: "info@quinterrasoft.com",
  phone: "+91 6304748719",
  address:
    "Quinterra Software Solutions Pvt. Ltd., Bangaru Building, Laxmareddy Palam, Hyderabad, Telangana, India",
  linkedin: "https://www.linkedin.com/company/quinterra-software-solutions/?viewAsMember=true",
};

export const siteMeta = {
  title: "Quinterra Software Solutions Pvt. Ltd. | AI SaaS Products for Business Automation",
  description:
    "Quinterra builds AI-powered SaaS products for HR, CRM, staffing, education, and enterprise operations using cloud infrastructure, AI, analytics, and automation.",
  url: "https://quinterrasoft.com",
};
